import React, { useEffect, useState, useContext } from "react";
import './Footer.css';
import logo from '../../Assest/LogoFooter.png';
import iconClock from '../../Assest/Clock.png';
import iconEmail from '../../Assest/email.png';
import iconFacebook from '../../Assest/Facebook.png';
import iconInstagram from '../../Assest/Instagram.png';
import iconLocation from '../../Assest/location.png';
import iconPhone from '../../Assest/phone.png';
import iconYoutube from '../../Assest/YouTube.png';
import iconCopyright from '../../Assest/Copyright.png'
import { NavLink } from "react-router-dom";
import { urlApiServer } from "../Config/Config";
import LoginContext from "../../Component/Context/LoginContext";
import Swal from "sweetalert2";

function Footer() {


    const urlGetCompanyInformations = urlApiServer + "company-informations"

    const { infoUser } = useContext(LoginContext)

    const [data, setData] = useState([]);

    useEffect(() => {
        (async function () {
            const startHeaders = new Headers();
            startHeaders.append("Content-Type", "application/json");

            const requestOptions = {
                method: 'GET',
                headers: startHeaders,
                redirect: 'follow',
            };

            try {
                const response = await fetch(urlGetCompanyInformations, requestOptions);
                if (response.ok) {
                    const companyInformationResponse = await response.json();
                    console.log('info del companyInformationResponse: ', companyInformationResponse.data);
                    setData(companyInformationResponse.data || []);
                } else {
                    console.error("Error en la respuesta de la API:", response.status);
                    setData([]); // Para evitar que sea null
                }
            } catch (error) {
                console.error('El backend está temporalmente desactivado:', error);
                setData([]); // Para evitar que sea null
            }
        })();
    }, [urlGetCompanyInformations]);

    const loggedInUser = () => {
        Swal.fire({
            title: "Error",
            text: "Ya estas vinculado",
            icon: "error",
            allowOutsideClick: false
        });
    }

    const userOffline = () => {
        Swal.fire({
            title: "Error",
            text: "Inicia sesion primero",
            icon: "error",
            allowOutsideClick: false
        });
    }


    return (
        <div className="containerFooter">
            <div className="containerOptionsAndInformation">
                <NavLink className="navLinks" to="/Inicio">
                    <div className="containerFooterLogo">
                        <img src={logo} alt="logo" className="logoFooter" />
                    </div>
                </NavLink>
                <div className="containerMenu">
                    <div className="containerTitleOpcionFooter">
                        <p className="titleOptionsFooter">Menú</p>
                    </div>
                    <div className="containerOpcionFooter">
                        <NavLink className="navLinks" to="/Quienes_Somos">
                            <p className="optionsFooter">¿Quienes somos?</p>
                        </NavLink>
                        <NavLink className="navLinks" to="/Comunicaciones">
                            <p className="optionsFooter">Comunicaciones</p>
                        </NavLink>
                        <NavLink className="navLinks" to="/Agendar">
                            <p className="optionsFooter">Asesoría Jurídica</p>
                        </NavLink>
                    </div>
                </div>
                <div className="containerMenu">
                    <div className="containerTitleOpcionFooter">
                        <p className="titleOptionsFooter">Usuario</p>
                    </div>
                    <div className="containerOpcionFooter">
                        {infoUser.isLoged === true ? (
                            <p className="optionsFooter" onClick={loggedInUser}>Vinculación</p>
                        ) : (
                            <NavLink className="navLinks" to="/Vinculacion">
                                <p className="optionsFooter">Vinculación</p>
                            </NavLink>
                        )}
                        {infoUser.isLoged === false ? (
                            <p className="optionsFooter" onClick={userOffline}>Actualización de datos</p>

                        ) : (
                            <NavLink className="navLinks" to="/Actualizar">
                                <p className="optionsFooter">Actualización de datos</p>
                            </NavLink>
                        )}
                        {infoUser.isLoged === false ? (
                            <p className="optionsFooter" onClick={userOffline}>Desvinculación</p>

                        ) : (
                            <NavLink className="navLinks" to="/Desvincular">
                                <p className="optionsFooter">Desvinculación</p>
                            </NavLink>
                        )}
                    </div>
                </div>
                <div className="containerMenu">
                    <div className="containerTitleOpcionFooter">
                        <p className="titleOptionsFooter">Contacto</p>
                    </div>
                    <div className="containerOpcionFooter">
                        <NavLink
                            to={`mailto:${data.length > 0 && data[0].correo ? data[0].correo : ""}`}  // Aquí va la dirección de correo
                            target="_blank"  // Abre en una nueva ventana (dependiendo del navegador y configuración del cliente de correo)
                            title={`Enviar correo a ${data.length > 0 && data[0].correo ? data[0].correo : "..."}`}  // El texto que se muestra cuando pasa el mouse sobre el ícono
                            style={{ textDecoration: 'none' }}  // Asegúrate de que no haya subrayado
                        >
                            <div className="CompanyOptionInformation">
                                <img src={iconEmail} alt="email" className="optionsFooter iconOpcions" />
                                <p className="optionsFooter optionFooterContact">Correo: {data.length > 0 && data[0].correo ? data[0].correo : "..."}</p>

                            </div>
                        </NavLink>
                        <div className="CompanyOptionInformation">
                            <div className="containerOpcionContact containerIconOpcionContact"><img src={iconLocation} alt="location" className="optionsFooter iconOpcions" /><p className="optionsFooter optionFooterContact">Ubicacion: {data.length > 0 && data[0].ubicacion ? data[0].ubicacion : "..."}</p></div>
                        </div>
                        <div className="CompanyOptionInformation">
                            <div className="containerOpcionContact containerIconOpcionContact"><img src={iconClock} alt="clock" className="optionsFooter iconOpcions" /><p className="optionsFooter optionFooterContact">Horario: {data.length > 0 && data[0].horario ? data[0].horario : "..."}</p></div>
                        </div>
                        <a
                            href={`tel:${data.length > 0 && data[0].telefono ? data[0].telefono : ""}`}  // Esto crea el enlace para hacer la llamada
                            title={`Llamar a ${data.length > 0 && data[0].telefono ? data[0].telefono : "..."}`}  // Muestra un popup con el número
                            className="containerOpcionContact containerIconOpcionContact"
                            style={{ textDecoration: 'none' }}  // Establece que no haya subrayado
                        >
                            <div className="CompanyOptionInformation">
                                <img src={iconPhone} alt="phone" className="iconOpcions" />
                                <p className="optionsFooter optionFooterContact">
                                    Teléfono: {data.length > 0 && data[0].telefono ? data[0].telefono : "..."}
                                </p>
                            </div>

                        </a>
                    </div>
                </div>
                <div className="containerMenu containerSocialNetwork">
                    <div className="containerTitleOpcionFooter">
                        <p className="titleOptionsFooter">Redes Sociales</p>
                    </div>
                    <div className="containerOpcionFooterSocialNetwork">
                        <NavLink
                            to={data.length > 0 && data[0].link_youtube ? data[0].link_youtube : "https://www.youtube.com"} // Aquí va la URL de redirección
                            target="_blank"  // Abre en una nueva ventana
                            title={data.length > 0 && data[0].youtube ? data[0].youtube : "youtube"} // El texto que se muestra cuando pasa el mouse sobre el ícono
                        >
                            <img src={iconYoutube} alt="youtube" className="iconsFooterSocialNetwork" />
                        </NavLink>
                        <NavLink
                            to={data.length > 0 && data[0].link_facebook ? data[0].link_facebook : "https://www.facebook.com"} // Aquí va la URL de redirección
                            target="_blank"  // Abre en una nueva ventana
                            title={data.length > 0 && data[0].facebook ? data[0].facebook : "Facebook"} // El texto que se muestra cuando pasa el mouse sobre el ícono
                        >
                            <img src={iconFacebook} alt="facebook" className="iconsFooterSocialNetwork" />
                        </NavLink>
                        <NavLink
                            to={data.length > 0 && data[0].link_instagram ? data[0].link_instagram : "https://www.instagram.com"} // Aquí va la URL de redirección
                            target="_blank"  // Abre en una nueva ventana
                            title={data.length > 0 && data[0].instagram ? data[0].instagram : "instagram"} // El texto que se muestra cuando pasa el mouse sobre el ícono

                        >
                            <img src={iconInstagram} alt="instagram" className="iconsFooterSocialNetwork" />
                        </NavLink>
                    </div>
                </div>
            </div >
            <div className="containerCopyright">
                <img src={iconCopyright} alt="copyright" />
                <p className="optionsFooter">singefin 2025 developed by Génios Tecnológicos</p>
            </div>
        </div >
    )
}

export default Footer